export default function BuildingsIcon() {
  return (
    <svg
      width="24"
      height="21"
      viewBox="0 0 24 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 19H4M4 19H14M4 19V5.2002C4 4.08009 4 3.51962 4.21799 3.0918C4.40973 2.71547 4.71547 2.40973 5.0918 2.21799C5.51962 2 6.08009 2 7.2002 2H10.8002C11.9203 2 12.4796 2 12.9074 2.21799C13.2837 2.40973 13.5905 2.71547 13.7822 3.0918C14 3.5192 14 4.07899 14 5.19691V11M14 19H20M14 19V11M14 11C14 10.0681 14 9.6024 14.1522 9.2349C14.3552 8.74481 14.7443 8.35523 15.2344 8.15224C15.6019 8 16.0679 8 16.9997 8C17.9316 8 18.3981 8 18.7656 8.15224C19.2557 8.35523 19.6447 8.74481 19.8477 9.2349C19.9999 9.6024 20 10.0681 20 11V19M20 19H22M7 9H11M7 6H11"
        stroke="currentColor"
        strokeWidth="2.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
